import React from "react";
import Alert from "@mui/material/Alert";
const FailAlert = ({ children }) => (
  <Alert
    severity="error"
    style={{
      marginTop: "1%",
      marginBottom: "1%",
      background: "#ff616e6b",
      color: "#eee",
    }}
  >
    {children}
  </Alert>
);
export default FailAlert;
